<template>
    <div>
        <HeaderPage />
        <HomeBody/>
    </div>
</template>

<script src="./HomeScreen.js"></script>